import * as SuperCategory from './SuperCategory';
export default [SuperCategory.MARKETING, SuperCategory.SALES, SuperCategory.CUSTOMER_SERVICE, SuperCategory.PRODUCTIVITY, SuperCategory.FINANCE];